import styled from 'styled-components';

export const ReceiptHeadInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ReceiptInfoLabel = styled.p`
  font-family: ${Styles.fontFamily.body};
  margin: 0 0.5rem 0 0;
`;

export const ReceiptInfoDetail = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${Styles.fontFamily.base};
`;

export const ReceiptInfo = styled.div`
  display: flex;
`;

export const Title = styled.h4`
  margin: 0;
  font-size: 1.25rem;
  font-family: ${Styles.fontFamily.base};
  color: ${Styles.color.black};
`;

export const ReceiptDate = styled(ReceiptInfoLabel)``;

export const ReceiptInfoDetailLabel = styled.p`
  margin: 0;
`;
